export default "__VITE_ASSET__Cy75bZwa__"